import JobCandidateFilter from "../../../../components/filteration/JobCandiditeFilter";
import { Container, Row, Col } from "react-bootstrap";
import ShopAdds from "../../../../components/shopAds/ShopAdds";
import Shops from "../../../../components/Multipleshopprofile/Components/Shops/Shops";
import { useEffect, useState, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import ShareModel from "../../../../components/Sharemodel";
import ShareOption from "../../../../components/Shareoption";
import BackArrow from "../../../../components/backArrow";
import { ShopContext } from "../../../../config/shopContext";
import { useGetShopCategoriesQuery } from "../../../../features/shop/shopApiSlice";
import { useLazyGetJobsFilterQuery, useGetJobsFilterQuery } from "../../../../features/user/userApiSlice";
import { JOBS_COMPANY_ALLOWED_CONNECT_TYPES } from "../../../../constants/businessTypeConnectionRules";

const FindJobFilter = () => {
  /* ===================== CONTEXT ===================== */
  const shopType = "jobs";
  const { name } = useSelector((state) => state.user);
  const { getFilteredData, updateFilteredData } = useContext(ShopContext);
  const currentData = getFilteredData(shopType);

  /* ===================== STATE ===================== */
  const [shopdata, setShopdata] = useState(currentData.shopdata || []);
  const [itemmdata, setItemmdata] = useState(currentData.itemmdata || []);

  const [showmodal, setShowmodal] = useState(false);
  const [showshare, setShowshare] = useState(false);

  const [dataCategory, setDataCategory] = useState({
    categoryid: "",
    title: "",
  });

  /* ===================== FILTERS (PERSISTENT) ===================== */
  const [filters, setFilters] = useState(
    currentData.additionalData || {
      companyname: "",
      companyid: "",
      shopCategoryid: "",
      marketplace: "",
      title: "",
      categoryid: "",
      subCategoryid: "",
      siteremote: "",
      jobtype: "",
      country: "",
      state: "",
      city: "",
    }
  );

  /* ===================== RTK QUERY ===================== */
  const { data: categoryRes } = useGetShopCategoriesQuery({ type: "company", parentCategory: "" });
  const shopCategoryone = categoryRes?.data?.Category || [];

  const [triggerGetJobsFilter, { isLoading: isFilterLoading }] = useLazyGetJobsFilterQuery();

  // Show all open jobs/companies by default, before the user runs any search,
  // mirroring the same-folder Available Candidates page's initial-load behavior.
  const hasPersistedData = (currentData.shopdata?.length || 0) > 0 || (currentData.itemmdata?.length || 0) > 0;
  const { data: initRes, isLoading: isInitialLoading } = useGetJobsFilterQuery(
    { filtermethod: "job" },
    { skip: hasPersistedData }
  );

  const isloading = isFilterLoading || (isInitialLoading && !hasPersistedData);

  useEffect(() => {
    if (hasPersistedData) return;
    if (initRes?.success) {
      setShopdata(initRes.AllCompanies || []);
      setItemmdata(initRes.Jobs || []);
      updateFilteredData(shopType, initRes.AllCompanies || [], initRes.Jobs || [], filters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initRes]);

  /* ===================== HANDLERS ===================== */
  const handleClosemodal = () => setShowmodal(false);
  const handleShow = () => setShowmodal(true);

  const handleCloseshare = () => {
    setShowshare(false);
    setShowmodal(true);
  };
  const handleShowshare = () => setShowshare(true);

  /* ===================== CATEGORY HANDLING ===================== */
  // Split only on the first "." so category names that contain dots stay intact.
  const parseIdName = (value = "") => {
    const idx = String(value).indexOf(".");
    if (idx === -1) return [value];
    return [value.slice(0, idx), value.slice(idx + 1)];
  };

  const Handledata = (e) => {
    const { name, value } = e.target;
    const parsed = parseIdName(value);

    setDataCategory((prev) => {
      // Title change invalidates category + subcategory; category change
      // invalidates subcategory so options stay in sync with the parent.
      if (name === "title") {
        return { title: parsed, categoryid: "" };
      }
      if (name === "categoryid") {
        return { ...prev, categoryid: parsed };
      }
      return { ...prev, [name]: parsed };
    });

    if (name === "title") {
      setFilters((prev) => ({
        ...prev,
        categoryid: "",
        subCategoryid: "",
      }));
    } else if (name === "categoryid") {
      setFilters((prev) => ({
        ...prev,
        subCategoryid: "",
      }));
    }
  };

  const categoryidone = dataCategory?.categoryid?.[0];
  const titleName = dataCategory?.title?.[1];

  useEffect(() => {
    setFilters(prev => ({
      ...prev,
      categoryid: categoryidone || "",
      title: titleName || "",
    }));
  }, [categoryidone, titleName]);

  /* ===================== INPUT HANDLERS ===================== */
  const Handlecompany = (e) => {
    setFilters(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const Handlejob = (e) => {
    setFilters(prev => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  /* ===================== FILTER BY COMPANY ===================== */
  const FilterCompanydetails = () => {
    setShopdata([]);
    setItemmdata([]);

    triggerGetJobsFilter({
      companyname: filters.companyname,
      companyid: filters.companyid,
      shopCategoryid: filters.shopCategoryid,
      marketplace: filters.marketplace,
      filtermethod: "company",
    })
      .unwrap()
      .then(res => {
        if (res?.success) {
          setShopdata(res.AllCompanies || []);
          setItemmdata(res.Jobs || []);
          updateFilteredData(
            shopType,
            res.AllCompanies || [],
            res.Jobs || [],
            filters
          );
        }
      })
      .catch(() => {});
  };

  /* ===================== FILTER BY JOB ===================== */
  const FilterJobDetails = () => {
    setShopdata([]);
    setItemmdata([]);

    triggerGetJobsFilter({
      title: filters.title,
      categoryid: filters.categoryid,
      subCategoryid: filters.subCategoryid,
      siteremote: filters.siteremote,
      jobtype: filters.jobtype,
      country: filters.country,
      state: filters.state,
      city: filters.city,
      filtermethod: "job",
    })
      .unwrap()
      .then(res => {
        if (res?.success) {
          setShopdata(res.AllCompanies || []);
          setItemmdata(res.Jobs || []);
          updateFilteredData(
            shopType,
            res.AllCompanies || [],
            res.Jobs || [],
            filters
          );
        }
      })
      .catch(() => {});
  };

  // Never suggest / list the logged-in user's own companies on this find-job page
  const visibleShopdata = useMemo(() => {
    const myId = name?._id ? String(name._id) : "";
    if (!myId || !Array.isArray(shopdata)) return shopdata || [];
    return shopdata.filter((shop) => {
      const ownerId = shop?.userid?._id || shop?.userid;
      return !ownerId || String(ownerId) !== myId;
    });
  }, [shopdata, name?._id]);

  /* ===================== UI ===================== */
  return (
    <>
      <ShareOption showshare={showshare} handleCloseshare={handleCloseshare} />
      <ShareModel
        showmodal={showmodal}
        handleClosemodal={handleClosemodal}
        handleShowshare={handleShowshare}
      />

      <Container>
        <Row>
          <Col lg="4" className="screenHeight">
            <BackArrow back="/BuyingSide" mystyle="ps-2 pt-1 d-lg-none" />
            <div className="border b-radius height_100">
              <JobCandidateFilter
                Handlecompany={Handlecompany}
                Handlejob={Handlejob}
                Handledata={Handledata}
                FilterCompanydetails={FilterCompanydetails}
                FilterJobDetails={FilterJobDetails}
                shopCategoryone={shopCategoryone}
                title="Search Category, Area & Desired Location"
                category="Search By Title"
                search="Search by Job Type"
                categoryName={dataCategory?.categoryid?.[1]}
                titleName={titleName}
              />
            </div>
          </Col>

          <Col lg="8" className="screenHeight">
            <div className="border b-radius ps-2 pe-2">
              <BackArrow back="/BuyingSide" mystyle="ps-2 pt-1 d-none d-lg-block" />
              <ShopAdds />
              <Shops
                link="/find-jobs-online"
                title="Jobs"
                isloading={isloading}
                data={0}
                handleShow={handleShow}
                shopdata={visibleShopdata}
                itemmdata={itemmdata}
                allowedConnectBusinessTypes={JOBS_COMPANY_ALLOWED_CONNECT_TYPES}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FindJobFilter;
